var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOcticonFile24(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19770_370606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7 19C19.1774 19 19.6352 18.8141 19.9728 18.4831C20.3104 18.1522 20.5 17.7033 20.5 17.2353V8.41176C20.5 7.94374 20.3104 7.49488 19.9728 7.16393C19.6352 6.83298 19.1774 6.64706 18.7 6.64706H11.59C11.289 6.64995 10.992 6.57877 10.7263 6.44004C10.4605 6.30131 10.2346 6.09945 10.069 5.85294L9.34 4.79412C9.1761 4.55012 8.95298 4.34983 8.69065 4.21123C8.42832 4.07263 8.135 4.00005 7.837 4H4.3C3.82261 4 3.36477 4.18592 3.02721 4.51687C2.68964 4.84782 2.5 5.29668 2.5 5.76471V17.2353C2.5 17.7033 2.68964 18.1522 3.02721 18.4831C3.36477 18.8141 3.82261 19 4.3 19H18.7Z",
    stroke: "#2094AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19770_370606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcticonFile24);
export default __webpack_public_path__ + "static/media/octicon_file-24.fe5583279c50e77c52441762d9425c60.svg";
export { ForwardRef as ReactComponent };